import { useState, useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { AuthModal } from "./AuthModal";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Check if user is authenticated
    if (!isAuthenticated) {
      setShowAuthModal(true);
    } else {
      setIsReady(true);
    }
  }, [isAuthenticated]);

  const handleAuthSuccess = () => {
    setShowAuthModal(false);
    setIsReady(true);
  };

  const handleAuthClose = () => {
    // If user closes modal without authenticating, redirect to home
    window.location.href = "/";
  };

  // Show loading state while checking auth
  if (!isReady && !showAuthModal) {
    return (
      <div className="min-h-screen bg-gradient-bg flex items-center justify-center">
        <div className="text-lg text-text-secondary uppercase tracking-widest font-bold">
          Loading...
        </div>
      </div>
    );
  }

  return (
    <>
      {isReady ? children : null}
      <AuthModal
        isOpen={showAuthModal}
        onClose={handleAuthClose}
        onSuccess={handleAuthSuccess}
      />
    </>
  );
};
